// Tremor Slider [v0.1.0]
"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cx, focusRing } from "../../lib/utils";
import { Text } from "../Text";
const Slider = React.forwardRef((_a, forwardedRef) => {
    var { className, ariaLabelThumb } = _a, props = __rest(_a, ["className", "ariaLabelThumb"]);
    const value = props.value || props.defaultValue;
    let first = value ? value[0] : 0;
    let second = value ? value[1] : 1;
    return (React.createElement("div", { className: "onvo-flex onvo-relative onvo-w-full onvo-flex-row onvo-items-center onvo-gap-2 onvo-bg-white dark:onvo-bg-gray-950 onvo-border onvo-border-gray-200 dark:onvo-border-gray-800 onvo-rounded-md onvo-px-3 onvo-py-1.5 onvo-shadow-sm" },
        React.createElement(Text, { className: "onvo-text-sm" }, first),
        React.createElement("div", { className: "onvo-relative onvo-flex-grow" },
            React.createElement(SliderPrimitive.Root, Object.assign({ ref: forwardedRef, className: cx(
                // base
                "onvo-relative onvo-flex onvo-cursor-pointer onvo-touch-none onvo-select-none", 
                // orientation
                "data-[orientation='horizontal']:onvo-w-full data-[orientation='horizontal']:onvo-items-center", "data-[orientation='vertical']:onvo-h-full data-[orientation='vertical']:onvo-w-fit data-[orientation='vertical']:onvo-justify-center", 
                // disabled
                "data-[disabled]:onvo-pointer-events-none", className), "tremor-id": "tremor-raw" }, props),
                React.createElement(SliderPrimitive.Track, { className: cx(
                    // base
                    "onvo-relative onvo-grow onvo-overflow-hidden onvo-rounded-full onvo-bg-gray-200 dark:onvo-bg-gray-800", 
                    // orientation
                    "data-[orientation='horizontal']:onvo-h-1.5 data-[orientation='horizontal']:onvo-w-full", "data-[orientation='vertical']:onvo-h-full data-[orientation='vertical']:onvo-w-1.5") },
                    React.createElement(SliderPrimitive.Range, { className: cx(
                        // base
                        "onvo-absolute onvo-rounded-full onvo-bg-blue-500 dark:onvo-bg-blue-500", 
                        // orientation
                        "data-[orientation='horizontal']:onvo-h-full", "data-[orientation='vertical']:onvo-w-full", 
                        // disabled
                        "data-[disabled]:onvo-bg-gray-300 dark:data-[disabled]:onvo-bg-gray-700") })), value === null || value === void 0 ? void 0 :
                value.map((_, index) => (React.createElement(SliderPrimitive.Thumb, { key: index, className: cx(
                    // base
                    "onvo-block onvo-size-[17px] onvo-shrink-0 onvo-rounded-full onvo-border onvo-shadow onvo-transition-all", 
                    // boder color
                    "onvo-border-gray-400 dark:onvo-border-gray-500", 
                    // background color
                    "onvo-bg-white", 
                    // disabled
                    "data-[disabled]:onvo-pointer-events-none data-[disabled]:onvo-bg-gray-200 dark:data-[disabled]:onvo-border-gray-800 dark:data-[disabled]:onvo-bg-gray-600", focusRing, "onvo-outline-offset-0"), "aria-label": ariaLabelThumb }))))),
        React.createElement(Text, { className: "onvo-text-sm" }, second)));
});
Slider.displayName = SliderPrimitive.Root.displayName;
export { Slider };
//# sourceMappingURL=Slider.js.map